module.exports = __webpack_public_path__ + "static/media/hourglass_circle_reded9d50cf8f8d8aea54968b3b4b781c50.webp";